module.exports = __webpack_public_path__ + "static/media/product_sample_5.5fed797d.avif";